import type * as React from "react";
import { VehicleCardSkeleton } from "@/components/booking/VehicleCardSkeleton";

const DEFAULT_SKELETON_COUNT = 6;

type BookingVehicleGridSkeletonProps = {
  count?: number;
};

export const BookingVehicleGridSkeleton: React.FC<
  BookingVehicleGridSkeletonProps
> = ({ count = DEFAULT_SKELETON_COUNT }) => {
  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <VehicleCardSkeleton key={`vehicle-skeleton-${index}`} />
      ))}
    </>
  );
};
